import { applyMiddleware, createStore } from 'redux';
//import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

//import loggerMiddleware from './middlewares/logger';
import rootReducer from './reducers';

export default function configureStore(preloadedState) {
    const middlewares = []; //[loggerMiddleware, thunkMiddleware];//
    const middlewareEnhancer = applyMiddleware(...middlewares);

    const enhancers = [middlewareEnhancer];
    const composedEnhancers = composeWithDevTools(...enhancers);

    let store;
    if (process.env.REACT_APP_ENVIRONMENT === 'production') {
        store = createStore(rootReducer, preloadedState);
    } else {
        store = createStore(rootReducer, preloadedState, composedEnhancers);
    }

    return store;
}
